import { Country, LearningObjective } from '@types';

export type DefaultProgramme = {
    id: number;
    title: string;
    description: string;
    year_id?: number;
    created_at: string;
    updated_at: string;
    learning_objectives: LearningObjective[];
    ai: boolean;
    status: ProgrammeStatusType | null;
    next_programme_id?: number | null;
};

export interface GBProgramme extends DefaultProgramme {
    country: Country.GB;
    key_stage?: number;
}

export interface USProgramme extends DefaultProgramme {
    country: Country.US;
    state_standard: string;
}

export type ProgrammeType = GBProgramme | USProgramme;

export enum ProgrammeStatusType {
    ARCHIVED = 'archived',
    DRAFT = 'draft',
    LIVE = 'live',
    TESTING = 'testing',
}
